import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import SEO from "../components/SEO";
import { BUSINESS, IMAGES } from "../lib/site";

const USES = [
  "Long journeys and motorway trips",
  "Holidays and towing",
  "General vehicle health checks",
  "Buying or selling a vehicle",
];

export default function InspectionPage() {
  return (
    <>
      <SEO
        title="Full Vehicle Inspection in Adlington £30 | PR7 MOT Centre"
        description="Full vehicle inspection in Adlington for £30. Peace of mind before a long journey, holiday or when buying and selling a vehicle. Serving Adlington, Chorley and Lancashire. Call 01257 786 540."
        path="/vehicle-inspection"
      />

      <section className="relative bg-navy overflow-hidden">
        <div className="absolute inset-0 eng-grid" />
        <div className="container-pr7 relative py-16 lg:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <p className="eyebrow-light mb-3">Full Vehicle Inspection</p>
            <h1 className="font-heading font-black text-white text-4xl sm:text-5xl tracking-tight leading-tight">
              Full Vehicle Inspection <span className="text-sky">- £30</span>
            </h1>
            <p className="text-pale/75 text-base sm:text-lg leading-relaxed mt-5 max-w-xl">
              Peace of mind before a long journey. A professional check-over of your vehicle at our Adlington workshop for just £30.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-7">
              <Link to="/booking?service=Full Vehicle Inspection" data-testid="inspection-book-btn" className="btn-primary">BOOK A VEHICLE INSPECTION <ArrowRight size={17} /></Link>
              <a href={BUSINESS.phoneHref} data-testid="inspection-call-btn" className="btn-outline-light">CALL {BUSINESS.phone}</a>
            </div>
          </div>
          <div className="lg:col-span-5">
            <img src={IMAGES.lift} alt="Vehicle raised on the ramp for a full inspection in Adlington" className="rounded-lg object-cover w-full h-72 lg:h-96 shadow-2xl" loading="eager" />
          </div>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-pr7 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-heading font-extrabold text-ink text-2xl sm:text-3xl tracking-tight">A proper look over your vehicle</h2>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Our full vehicle inspection is a thorough visual and mechanical check of your vehicle's key systems and safety components. We look at the areas that matter most - brakes, tyres, suspension, steering, fluids, lights and general condition - and give you a clear, honest summary of what we find.
            </p>
            <p className="text-muted-foreground leading-relaxed mt-4">
              It is a simple, affordable way to know where you stand with your vehicle, without committing to any repair work. If we do find anything, we explain it plainly and quote before doing anything further.
            </p>
          </div>
          <div>
            <div className="bg-pale border border-brand/20 rounded-lg p-7">
              <h2 className="font-heading font-extrabold text-ink text-xl tracking-tight">Ideal for</h2>
              <ul className="mt-4 space-y-3">
                {USES.map((u) => (
                  <li key={u} className="flex gap-3 text-sm text-muted-foreground">
                    <CheckCircle2 size={17} className="text-brand shrink-0 mt-0.5" /> {u}
                  </li>
                ))}
              </ul>
              <div className="mt-6 pt-5 border-t border-brand/15 flex items-center justify-between">
                <p className="font-mono font-semibold text-brand text-3xl">£30</p>
                <Link to="/booking?service=Full Vehicle Inspection" data-testid="inspection-book-bottom-btn" className="btn-primary !px-5 !py-2.5 text-sm">
                  BOOK INSPECTION <ArrowRight size={15} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
